import "./styles.css";

import { useState, useEffect } from "react";
import ProductList from "./ProductList";
import Cart from "./Cart";
import CartDetails from "./CartDetails";

function App() {
  const [products] = useState([
    { id: 1, name: "Laptop", price: 50000 },
    { id: 2, name: "Mobile", price: 20000 },
    { id: 3, name: "Headphones", price: 2000 },
    { id: 4, name: "Keyboard", price: 1500 },
    { id: 5, name: "Mouse", price: 800 },
  ]);

  // const [cartItems, setCartItems] = useState([]);
  const [cartItems, setCartItems] = useState(() => {
    // 1. Look for the saved string in localStorage
    const savedCart = localStorage.getItem("shoppingCart");

    // 2. If it exists, convert the string back into a JavaScript array.
    // 3. If it doesn't exist, fall back to an empty array [].
    return savedCart ? JSON.parse(savedCart) : [];
  });

  // [ { cid: autoGenerate, pId: '', qty:  } ]

  const addToCart = (pId) => {
    if (
      cartItems.find((ele) => {
        return ele.pId === pId;
      })
    ) {
      setCartItems(
        cartItems.map((ele) => {
          if (ele.pId === pId) {
            return { ...ele, quantity: ele.quantity + 1 };
          } else {
            // Return other elements
            return ele;
          }
        })
      );
    } else {
      const newItem = { cid: crypto.randomUUID(), pId: pId, quantity: 1 };
      setCartItems([...cartItems, newItem]);
    }
  };

  const increaseQuantity = (cId) => {
    setCartItems(
      cartItems.map((ele) => {
        if (ele.cid === cId) {
          return { ...ele, quantity: ele.quantity + 1 };
        } else {
          return ele;
        }
      })
    );
  };

  const decreaseQuantity = (cId) => {
    // setCartItems(
    //   cartItems.map((ele) => {
    //     if (ele.cid === cId) {
    //       if (ele.quantity > 1) {
    //         return { ...ele, quantity: ele.quantity - 1 };
    //       } else {
    //         return ele;
    //       }
    //     } else {
    //       return ele;
    //     }
    //   })
    // );

    const targetItem = cartItems.find((ele) => {
      return ele.cid === cId;
    });

    if (targetItem.quantity === 1) {
      removeItem(cId);
    } else {
      setCartItems(
        cartItems.map((ele) => {
          if (ele.cid === cId) {
            return { ...ele, quantity: ele.quantity - 1 };
          } else {
            return ele;
          }
        })
      );
    }
  };

  const removeItem = (cId) => {
    setCartItems(
      cartItems.filter((ele) => {
        return ele.cid !== cId;
      })
    );
  };

  useEffect(() => {
    localStorage.setItem("shoppingCart", JSON.stringify(cartItems));
  }, [cartItems]);

  // helper function
  const findProduct = (pId) => {
    return products.find((ele) => {
      return ele.id === pId;
    });
  };

  return (
    <div className="container">
      <h1 className="title">Shopping Cart</h1>

      <div className="layout">
        <div className="card">
          <ProductList products={products} addToCart={addToCart} />
        </div>

        <div>
          <div className="card">
            <Cart
              cartItems={cartItems}
              increaseQuantity={increaseQuantity}
              decreaseQuantity={decreaseQuantity}
              removeItem={removeItem}
              // Additional props
              // products={products}
              findProduct={findProduct}
            />
          </div>

          <div className="card">
            <CartDetails
              cartItems={cartItems}
              // Additional props
              // products={products}
              findProduct={findProduct}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
